import PresetsContent from './PresetsContent.jsx';

export default function TabletPresetsModal() {
  return <PresetsContent />;
}
